export const initialState = {
    user: null,
    tour: {
        isActive: false,
        currentStep: 0,
        currentPageIndex: 0,
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'USER_LOADED':
            localStorage.setItem('sessionId', action.payload?.sessionId ?? '');
            return {
                ...state,
                user: action.payload,
            };
        case 'TOUR_STARTED':
            return {
                ...state,
                tour: {
                    ...state.tour,
                    isActive: true,
                    currentStep: 0,
                    currentPageIndex: 0,
                },
            };
        case 'TOUR_ENDED':
            return {
                ...state,
                tour: {
                    ...state.tour,
                    isActive: false,
                    currentStep: 0,
                    currentPageIndex: 0,
                },
            };
        case 'TOUR_STEP_CHANGED':
            return {
                ...state,
                tour: {
                    ...state.tour,
                    currentStep: action.payload,
                },
            };
        default:
            return state;
    }
};
